module.exports = __webpack_public_path__ + "img/logs.95d625e6.svg";